import { MRT_ColumnDef } from "material-react-table";
import { Job } from "../../../../api";
import { ColumnContext, selectColumn } from "./ColumnHelpers";

export function column_TestPackage(context: ColumnContext): MRT_ColumnDef<Job, unknown> {
	return selectColumn(context, "externalTestPackageId", "testPackage", {
		options: context.labPackages,
		updateSubRows: context.dealBasedSubRowUpdate,
	});
}
